import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
    class: "w-80 bg-white h-3/4 border-r border-b rounded-br-lg border-gray-200 flex flex-col items-center px-4",
    id: "v-picker"
};
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("hr", { class: "bg-gray-200 h-[1px] w-full mb-2" }, null, -1);
const _hoisted_3 = { class: "flex flex-col gap-2 overflow-scroll h-full relative pb-2" };
const _hoisted_4 = { class: "sticky top-0 bg-white py-0.5" };
const _hoisted_5 = { class: "space-y-2 mt-2 px-1 pb-2" };
const _hoisted_6 = {
    key: 0,
    class: "font-semibold text-center"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["title"];
const _hoisted_9 = { class: "flex flex-col gap-2 overflow-scroll h-full relative pb-2" };
const _hoisted_10 = { class: "sticky top-0 bg-white py-0.5" };
const _hoisted_11 = { class: "space-y-2 mt-2 px-1 pb-2" };
const _hoisted_12 = {
    key: 0,
    class: "font-semibold text-center"
};
const _hoisted_13 = ["onClick"];
const _hoisted_14 = ["title"];
const _hoisted_15 = { class: "flex flex-col gap-2 overflow-scroll h-full relative pb-2" };
const _hoisted_16 = { class: "sticky top-0 bg-white py-0.5" };
const _hoisted_17 = { class: "space-y-2 mt-2 px-1 pb-2" };
const _hoisted_18 = {
    key: 0,
    class: "font-semibold text-center"
};
const _hoisted_19 = ["onClick"];
const _hoisted_20 = { class: "text-[13px] truncate" };
import calendarWidgetState from '@/helper/calendarWidgetStates';
import { ACTIVE_CALENDARS_LS_KEY_FN, ACTIVE_GROUPS_LS_KEY_FN, ACTIVE_USERS_LS_KEY_FN, ACTIVE_VIEW_LS_KEY_FN, } from '@/helper/const';
import { getStartDayOfWeek } from '@/helper/helper';
import { CheckIcon, SearchLgIcon } from '@gohighlevel/ghl-icons/24/outline';
import { UIDatepicker, UIInput, UITabPane, UITabs } from '@gohighlevel/ghl-ui';
import { computed, ref, watchEffect } from 'vue';
import { useI18n } from 'vue-i18n';
export default /*#__PURE__*/ _defineComponent({
    __name: 'SideDrawer',
    props: {
        onDateChange: Function,
        locationId: String,
        timezone: String,
        activeDate: Date,
        userId: String,
        calendars: {
            type: Array,
            default: () => [],
        },
        groups: {
            type: Array,
            default: () => [],
        },
        users: {
            type: Array,
            default: () => [],
        },
        data: null,
    },
    setup(__props) {
        const props = __props;
        const calendarArray = ref([]);
        const groupArray = ref([]);
        const userArray = ref([]);
        const selectedCalendar = ref([]);
        const selectedGroup = ref([]);
        const selectedUser = ref([]);
        const search = ref('');
        const { t } = useI18n();
        const placeholderText = computed(() => {
            switch (calendarWidgetState.activeView) {
                case 'calendar':
                    return t('calendarOverlay.search_for_calendar');
                case 'group':
                    return t('calendarOverlay.search_for_group');
                case 'user':
                    return t('calendarOverlay.search_for_user');
                default:
                    return '';
            }
        });
        const handleCheckboxChange = (value, type) => {
            var _a, _b, _c, _d, _e, _f;
            if (type == 'calendar') {
                calendarWidgetState.activeView = 'calendar';
                if (selectedCalendar.value.includes(value)) {
                    selectedCalendar.value = selectedCalendar.value.filter((item) => item != value);
                    if (selectedCalendar.value.length == 0) {
                        calendarWidgetState.refreshEvents =
                            calendarWidgetState.refreshEvents + 1;
                    }
                }
                else {
                    selectedCalendar.value.push(value);
                }
            }
            if (type == 'group') {
                calendarWidgetState.activeView = 'group';
                if (selectedGroup.value.includes(value)) {
                    selectedGroup.value = selectedGroup.value.filter((item) => item != value);
                    if (selectedCalendar.value.length == 0) {
                        calendarWidgetState.refreshEvents =
                            calendarWidgetState.refreshEvents + 1;
                    }
                }
                else {
                    selectedGroup.value.push(value);
                }
            }
            if (type == 'user') {
                calendarWidgetState.activeView = 'user';
                if (selectedUser.value.includes(value)) {
                    selectedUser.value = selectedUser.value.filter((item) => item != value);
                    if (selectedCalendar.value.length == 0) {
                        calendarWidgetState.refreshEvents =
                            calendarWidgetState.refreshEvents + 1;
                    }
                }
                else {
                    selectedUser.value.push(value);
                }
            }
            calendarWidgetState.calendarIds = selectedCalendar.value;
            calendarWidgetState.groupIds = selectedGroup.value;
            calendarWidgetState.userIds = selectedUser.value;
            localStorage.setItem(ACTIVE_CALENDARS_LS_KEY_FN(props.locationId, (_b = (_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.loggedInUserInfo) === null || _b === void 0 ? void 0 : _b.id), JSON.stringify(calendarWidgetState.calendarIds));
            localStorage.setItem(ACTIVE_GROUPS_LS_KEY_FN(props.locationId, (_d = (_c = props === null || props === void 0 ? void 0 : props.data) === null || _c === void 0 ? void 0 : _c.loggedInUserInfo) === null || _d === void 0 ? void 0 : _d.id), JSON.stringify(calendarWidgetState.groupIds));
            localStorage.setItem(ACTIVE_USERS_LS_KEY_FN(props.locationId, (_f = (_e = props === null || props === void 0 ? void 0 : props.data) === null || _e === void 0 ? void 0 : _e.loggedInUserInfo) === null || _f === void 0 ? void 0 : _f.id), JSON.stringify(calendarWidgetState.userIds));
        };
        function handleTabChange(key) {
            var _a, _b;
            localStorage.setItem(ACTIVE_VIEW_LS_KEY_FN(props.locationId, (_b = (_a = props === null || props === void 0 ? void 0 : props.data) === null || _a === void 0 ? void 0 : _a.loggedInUserInfo) === null || _b === void 0 ? void 0 : _b.id), key);
            calendarWidgetState.activeView = key;
            calendarWidgetState.events = [];
            search.value = '';
        }
        function generateName(o) {
            if (o.name)
                return o.name;
            if (o.firstName && o.lastName)
                return `${o.firstName} ${o.lastName}`;
        }
        watchEffect(() => {
            selectedCalendar.value = calendarWidgetState.calendarIds;
            selectedGroup.value = calendarWidgetState.groupIds;
            selectedUser.value = calendarWidgetState.userIds;
        });
        watchEffect(() => {
            if (calendarWidgetState.activeView === 'group') {
                if (search.value == '') {
                    groupArray.value = props.groups;
                }
                else {
                    groupArray.value = props.groups.filter((group) => {
                        var _a, _b;
                        return (_b = (_a = group.calendarProviderName) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes(search.value.toLowerCase());
                    });
                }
            }
            else if (calendarWidgetState.activeView === 'user') {
                if (search.value == '') {
                    userArray.value = props.users;
                }
                else {
                    userArray.value = props.users.filter((user) => {
                        var _a, _b, _c;
                        return (((_a = user === null || user === void 0 ? void 0 : user.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(search.value.toLowerCase())) ||
                            ((_b = user === null || user === void 0 ? void 0 : user.firstName) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(search.value.toLowerCase())) ||
                            ((_c = user === null || user === void 0 ? void 0 : user.lastName) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(search.value.toLowerCase())));
                    });
                }
            }
            else if (calendarWidgetState.activeView === 'calendar') {
                if (search.value == '') {
                    calendarArray.value = props.calendars;
                }
                else {
                    calendarArray.value = props.calendars.filter((calendar) => {
                        var _a, _b;
                        return (_a = calendar === null || calendar === void 0 ? void 0 : calendar.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes((_b = search.value) === null || _b === void 0 ? void 0 : _b.toLowerCase());
                    });
                }
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(UIDatepicker), {
                    actions: [],
                    id: "date-picker",
                    panel: true,
                    "onUpdate:value": _cache[0] || (_cache[0] = val => props.onDateChange(val)),
                    value: new Date(props.activeDate).valueOf(),
                    "first-day-of-week": _unref(getStartDayOfWeek)(_unref(calendarWidgetState).startDayOfWeek)
                }, null, 8, ["value", "first-day-of-week"]),
                _hoisted_2,
                _createVNode(_unref(UITabs), {
                    "onUpdate:value": [
                        _cache[4] || (_cache[4] = val => handleTabChange(val)),
                        _cache[5] || (_cache[5] = ($event) => ((_unref(calendarWidgetState).activeView) = $event))
                    ],
                    "default-value": _unref(calendarWidgetState).activeView,
                    value: _unref(calendarWidgetState).activeView
                }, {
                    default: _withCtx(() => {
                        var _a, _b, _c;
                        return [
                            ((_a = props === null || props === void 0 ? void 0 : props.users) === null || _a === void 0 ? void 0 : _a.length)
                                ? (_openBlock(), _createBlock(_unref(UITabPane), {
                                    key: 0,
                                    name: "user",
                                    tab: _ctx.$t('calendarOverlay.users')
                                }, {
                                    default: _withCtx(() => {
                                        var _a;
                                        return [
                                            _createElementVNode("div", _hoisted_3, [
                                                _createElementVNode("div", _hoisted_4, [
                                                    _createVNode(_unref(UIInput), {
                                                        id: "search",
                                                        modelValue: search.value,
                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((search).value = $event)),
                                                        placeholder: placeholderText.value
                                                    }, {
                                                        prefix: _withCtx(() => [
                                                            _createVNode(_unref(SearchLgIcon))
                                                        ]),
                                                        _: 1
                                                    }, 8, ["modelValue", "placeholder"])
                                                ]),
                                                _createElementVNode("div", _hoisted_5, [
                                                    (((_a = userArray.value) === null || _a === void 0 ? void 0 : _a.length) === 0)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                                            _createElementVNode("span", null, _toDisplayString(_unref(t)('calendarOverlay.no_matching_user_found')), 1)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userArray.value, (option) => {
                                                        return (_openBlock(), _createElementBlock("button", {
                                                            onClick: ($event) => (handleCheckboxChange(option.id, 'user')),
                                                            key: option.id,
                                                            class: "flex gap-2 items-center w-full"
                                                        }, [
                                                            _createElementVNode("span", {
                                                                class: _normalizeClass(`h-4 w-4 min-w-[16px] block border rounded border-black/50`),
                                                                style: _normalizeStyle(selectedUser.value.includes(option.id)
                                                                    ? `border: 1.5px solid ${option.eventColor}; background-color: ${option.eventColor + '19'}`
                                                                    : '')
                                                            }, [
                                                                (selectedUser.value.includes(option.id))
                                                                    ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                                                                        key: 0,
                                                                        style: _normalizeStyle(`color: ${option.eventColor}`)
                                                                    }, null, 8, ["style"]))
                                                                    : _createCommentVNode("", true)
                                                            ], 4),
                                                            _createElementVNode("span", {
                                                                title: generateName(option),
                                                                class: "text-left text-[13px] flex-1 truncate"
                                                            }, _toDisplayString(generateName(option)), 9, _hoisted_8)
                                                        ], 8, _hoisted_7));
                                                    }), 128))
                                                ])
                                            ])
                                        ];
                                    }),
                                    _: 1
                                }, 8, ["tab"]))
                                : _createCommentVNode("", true),
                            ((_b = props === null || props === void 0 ? void 0 : props.calendars) === null || _b === void 0 ? void 0 : _b.length)
                                ? (_openBlock(), _createBlock(_unref(UITabPane), {
                                    key: 1,
                                    name: "calendar",
                                    tab: _ctx.$t('calendarOverlay.calendars')
                                }, {
                                    default: _withCtx(() => {
                                        var _a;
                                        return [
                                            _createElementVNode("div", _hoisted_9, [
                                                _createElementVNode("div", _hoisted_10, [
                                                    _createVNode(_unref(UIInput), {
                                                        id: "search",
                                                        modelValue: search.value,
                                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((search).value = $event)),
                                                        placeholder: placeholderText.value,
                                                        class: "sticky top-0 mb-2"
                                                    }, {
                                                        prefix: _withCtx(() => [
                                                            _createVNode(_unref(SearchLgIcon))
                                                        ]),
                                                        _: 1
                                                    }, 8, ["modelValue", "placeholder"])
                                                ]),
                                                _createElementVNode("div", _hoisted_11, [
                                                    (((_a = calendarArray.value) === null || _a === void 0 ? void 0 : _a.length) === 0)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                            _createElementVNode("span", null, _toDisplayString(_unref(t)('calendarOverlay.no_matching_calendar_found')), 1)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(calendarArray.value, (option) => {
                                                        return (_openBlock(), _createElementBlock("button", {
                                                            onClick: ($event) => (handleCheckboxChange(option.id, 'calendar')),
                                                            key: option.id,
                                                            class: "flex gap-2 items-center w-full"
                                                        }, [
                                                            _createElementVNode("span", {
                                                                class: _normalizeClass(`h-4 w-4 min-w-[16px] block border rounded border-black/50`),
                                                                style: _normalizeStyle(selectedCalendar.value.includes(option.id)
                                                                    ? `border: 1.5px solid ${option.eventColor}; background-color: ${option.eventColor + '19'}`
                                                                    : '')
                                                            }, [
                                                                (selectedCalendar.value.includes(option.id))
                                                                    ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                                                                        key: 0,
                                                                        style: _normalizeStyle(`color: ${option.eventColor}`)
                                                                    }, null, 8, ["style"]))
                                                                    : _createCommentVNode("", true)
                                                            ], 4),
                                                            _createElementVNode("span", {
                                                                title: option.name,
                                                                class: "text-left text-[13px] truncate"
                                                            }, _toDisplayString(option.name || (option === null || option === void 0 ? void 0 : option.firstName) + ' ' + (option === null || option === void 0 ? void 0 : option.lastName)), 9, _hoisted_14)
                                                        ], 8, _hoisted_13));
                                                    }), 128))
                                                ])
                                            ])
                                        ];
                                    }),
                                    _: 1
                                }, 8, ["tab"]))
                                : _createCommentVNode("", true),
                            ((_c = props === null || props === void 0 ? void 0 : props.groups) === null || _c === void 0 ? void 0 : _c.length)
                                ? (_openBlock(), _createBlock(_unref(UITabPane), {
                                    key: 2,
                                    name: "group",
                                    tab: _ctx.$t('calendarOverlay.groups')
                                }, {
                                    default: _withCtx(() => {
                                        var _a;
                                        return [
                                            _createElementVNode("div", _hoisted_15, [
                                                _createElementVNode("div", _hoisted_16, [
                                                    _createVNode(_unref(UIInput), {
                                                        id: "search",
                                                        modelValue: search.value,
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((search).value = $event)),
                                                        placeholder: placeholderText.value,
                                                        class: "sticky top-0 mb-2"
                                                    }, {
                                                        prefix: _withCtx(() => [
                                                            _createVNode(_unref(SearchLgIcon))
                                                        ]),
                                                        _: 1
                                                    }, 8, ["modelValue", "placeholder"])
                                                ]),
                                                _createElementVNode("div", _hoisted_17, [
                                                    (((_a = groupArray.value) === null || _a === void 0 ? void 0 : _a.length) === 0)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                            _createElementVNode("span", null, _toDisplayString(_unref(t)('calendarOverlay.no_matching_group_found')), 1)
                                                        ]))
                                                        : _createCommentVNode("", true),
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupArray.value, (option) => {
                                                        return (_openBlock(), _createElementBlock("button", {
                                                            onClick: ($event) => (handleCheckboxChange(option.id, 'group')),
                                                            key: option.id,
                                                            class: "flex gap-2 items-center w-full"
                                                        }, [
                                                            _createElementVNode("span", {
                                                                class: _normalizeClass(`h-4 w-4 min-w-[16px] block border rounded border-black/50`),
                                                                style: _normalizeStyle(selectedGroup.value.includes(option.id)
                                                                    ? `border: 1.5px solid ${option.eventColor}; background-color: ${option.eventColor + '19'}`
                                                                    : '')
                                                            }, [
                                                                (selectedGroup.value.includes(option.id))
                                                                    ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                                                                        key: 0,
                                                                        style: _normalizeStyle(`color: ${option.eventColor}`)
                                                                    }, null, 8, ["style"]))
                                                                    : _createCommentVNode("", true)
                                                            ], 4),
                                                            _createElementVNode("span", _hoisted_20, _toDisplayString(option.calendarProviderName || option.name), 1)
                                                        ], 8, _hoisted_19));
                                                    }), 128))
                                                ])
                                            ])
                                        ];
                                    }),
                                    _: 1
                                }, 8, ["tab"]))
                                : _createCommentVNode("", true)
                        ];
                    }),
                    _: 1
                }, 8, ["default-value", "value"])
            ]));
        };
    }
});
